<section id="services" class="padded-section">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="center-heading">
          <h2>¿Qué ofrecemos?</h2>
          <span class="center-line"></span>
        </div>
      </div>
    </div>
    <!--center heading row-->
    <div class="row">
      <div class="col-md-4 col-sm-6 margin20">
        <div
          class="services-box wow animated fadeInUp animated"
          data-wow-duration="700ms"
          data-wow-delay="100ms"
          style="
            visibility: visible;
            -webkit-animation-duration: 700ms;
            -webkit-animation-delay: 100ms;
          "
        >
          <div class="services-box-icon">
            <mat-icon>account_balance_wallet</mat-icon>
          </div>
          <!--services icon-->
          <div class="services-box-info">
            <h4>Control Administrativo</h4>
            <p>
              Organiza, controla y moderniza la gestión administrativa de tu parroquia o comunidad
              religiosa con nuestro sistema especializado. Nuestro programa administrativo está
              diseñado exclusivamente para iglesias católicas, ofreciendo herramientas poderosas y
              fáciles de usar que permiten llevar un control ordenado, transparente y eficiente de
              todas las actividades administrativas.
            </p>
          </div>
        </div>
        <!--services box-->
      </div>
      <!--services col-->
      <div class="col-md-4 col-sm-6 margin20">
        <div
          class="services-box wow animated fadeInUp animated"
          data-wow-duration="700ms"
          data-wow-delay="200ms"
          style="
            visibility: visible;
            -webkit-animation-duration: 700ms;
            -webkit-animation-delay: 200ms;
          "
        >
          <div class="services-box-icon">
            <mat-icon>equalizer</mat-icon>
          </div>
          <!--services icon-->
          <div class="services-box-info">
            <h4>Reportes</h4>
            <p>
              Este programa brinda la posibilidad de generar reportes claros y confiables al
              instante, ya sea de manera diaria, semanal, mensual o comparativa. Asimismo, permite
              personalizar los informes por rangos de fechas específicos, optimizando la
              administración y el control de la información.
            </p>
          </div>
        </div>
        <!--services box-->
      </div>
      <!--services col-->
      <div class="col-md-4 col-sm-6 margin20">
        <div
          class="services-box wow animated fadeInUp animated"
          data-wow-duration="700ms"
          data-wow-delay="300ms"
          style="
            visibility: visible;
            -webkit-animation-duration: 700ms;
            -webkit-animation-delay: 300ms;
          "
        >
          <div class="services-box-icon">
            <mat-icon>calendar_month</mat-icon>
          </div>
          <!--services icon-->
          <div class="services-box-info">
            <h4>Calendario</h4>
            <p>
              El software cuenta con un calendario integrado que permite organizar y visualizar
              todas las actividades, eventos y compromisos en una sola agenda digital. Gracias a
              esta herramienta, los usuarios pueden consultar en tiempo real su programación, lo que
              reduce la posibilidad de errores, olvidos o duplicación de actividades.
            </p>
          </div>
        </div>
        <!--services box-->
      </div>
      <!--services col-->

      <div class="col-md-4 col-sm-6 margin20">
        <div
          class="services-box wow animated fadeInUp animated"
          data-wow-duration="700ms"
          data-wow-delay="400ms"
          style="
            visibility: visible;
            -webkit-animation-duration: 700ms;
            -webkit-animation-delay: 400ms;
          "
        >
          <div class="services-box-icon">
            <mat-icon>church</mat-icon>
          </div>
          <!--services icon-->
          <div class="services-box-info">
            <h4>Ubicaciones</h4>
            <p>
              Es un programa flexible en el que el usuario puede crear y nombrar lugares de acuerdo
              a sus necesidades, asignándoles el nombre que prefiera para que le resulte fácil
              identificarlos.
            </p>
          </div>
        </div>
        <!--services box-->
      </div>
      <!--services col-->
      <div class="col-md-4 col-sm-6 margin20">
        <div
          class="services-box wow animated fadeInUp animated"
          data-wow-duration="700ms"
          data-wow-delay="500ms"
          style="
            visibility: visible;
            -webkit-animation-duration: 700ms;
            -webkit-animation-delay: 500ms;
          "
        >
          <div class="services-box-icon">
            <mat-icon>category</mat-icon>
          </div>
          <!--services icon-->
          <div class="services-box-info">
            <h4>Categorías y Subcategorías</h4>
            <p>
              El sistema permite organizar la información en categorías y subcategorías
              personalizadas, añadiendo descripciones con los términos que resulten más familiares.
              De esta manera, la estructura del sistema se adapta al lenguaje y a la forma de
              trabajo de cada persona.
            </p>
          </div>
        </div>
        <!--services box-->
      </div>
      <!--services col-->
    </div>
    <!--services row-->
  </div>
</section>
<!--services-->
